<div id="ncc" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">National Cadet Corps (NCC)</h2>
    <p class="inner-lead mt-3">
      Our college proudly boasts a long-standing tradition of excellence in the National Cadet Corps (NCC). For many
      years, our NCC program has been a cornerstone of student development, fostering discipline, leadership, and a
      sense of service among our cadets. In the 2023-24 session, we expanded our horizons by introducing the Air Wing
      NCC, further enriching our NCC program and providing new opportunities for our students.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">NCC Achievements</h4>
    <p>Our cadets have consistently excelled in various NCC camps and activities, showcasing their dedication, skill,
      and exemplary conduct. Whether participating in national camps, state-level competitions, or community service
      projects, our cadets are always ready to represent our college with pride and distinction.</p>

    <h4 class="section-subtitle mt-4">Selection Process</h4>
    <p>Every year, on NCC Foundation Day, we conduct a rigorous selection process to identify and recruit the most
      promising students into our NCC program. This selection system is designed to assess physical fitness, leadership
      potential, and commitment to the NCC's values. The tough selection process ensures that only the best candidates
      join our ranks, maintaining the high standards of our NCC unit.</p>

    <h4 class="section-subtitle mt-4">New Developments</h4>
    <p>The recent addition of the Air Wing NCC marks a significant milestone for our college. This new wing offers
      cadets the opportunity to explore aviation-related activities and training, broadening their horizons and
      equipping them with unique skills. The Air Wing NCC has already made a remarkable impact, with cadets
      demonstrating exceptional performance in various camps and events.</p>

    <h4 class="section-subtitle mt-4">Commitment to Excellence</h4>
    <p>Our NCC cadets are more than just participants; they are leaders and ambassadors of our college's values. Their
      unwavering readiness and dedication to their duties exemplify the spirit of the NCC. Through their involvement,
      cadets develop qualities that prepare them for future challenges, both in their personal and professional lives.
    </p>

    <h4 class="section-subtitle mt-4">Join Us</h4>
    <p>We invite all eligible students to consider joining the NCC and becoming part of a legacy of excellence and
      service. Through rigorous training, diverse activities, and a commitment to community and nation, our NCC program
      offers an unparalleled opportunity for personal growth and development. Together, let's continue to uphold the
      proud tradition of the NCC at our college, nurturing future leaders who are ready to serve and excel in every
      endeavour.</p>

    <ul class="list-styled mt-3">
      <li><strong>Lieutenant:</strong> Ms. Sarita</li>
      <li><strong>Air Wing Incharge:</strong> Ms. Priyanka</li>
      <li><strong>ANO:</strong> Ms. Suman Rani</li>
    </ul>

    <hr class="divider">

    <h4 class="section-subtitle">NCC Reports</h4>
    <div class="row g-3 mt-2">
      <div class="col-md-4">
        <a href="/assets/pdf/campus-life/NCC-2023-24.pdf" target="_blank" class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>NCC 2023-24
        </a>
      </div>
      <div class="col-md-4">
        <a href="/assets/pdf/campus-life/NCC-2022-23.pdf" target="_blank" class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>NCC 2022-23
        </a>
      </div>
      <div class="col-md-4">
        <a href="/assets/pdf/campus-life/NCC-2021-22.pdf" target="_blank" class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>NCC 2021-22
        </a>
      </div>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Photo Gallery</h4>
    <div class="row g-3 mt-2 mb-4">
      <div class="col-6 col-md-3" *ngFor="let img of nccImages">
        <div class="rounded-4 overflow-hidden shadow-sm border border-2 border-white">
          <img [src]="img" alt="NCC Activity" class="img-fluid w-100" style="object-fit: cover; height: 180px;">
        </div>
      </div>
    </div>

  </div>
</div>